const closeIcon = () => (
    <svg id="icon-close" width="25" height="25" viewBox="0 0 25 25">
        <path d="M12.71 12L23.85.85a.5.5 0 0 0-.7-.7L12 11.29.85.15a.502.502 0 0 0-.71.71L11.29 12 .15 23.15a.502.502 0 0 0 .71.71L12 12.71l11.15 11.14a.502.502 0 1 0 .71-.71L12.71 12z" />
    </svg>
);

export default closeIcon;
